import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const path = '../oldPages/e-insert-management/edit/index.html';

const links: Record<string, string> = {
  submit: '/infoTrac/e-insert-management?act=submitted',
  back: '/infoTrac/e-insert-management',
};

function EInsertManagementEdit() {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleIframeLoad = () => {
      const iframeDocument = iframeRef.current?.contentDocument || iframeRef.current?.contentWindow?.document;

      if (!iframeDocument) return;

      const submit = iframeDocument.getElementById('submitBtn');
      const back = iframeDocument.getElementById('backBtn');

      if (submit) submit.addEventListener('click', () => navigate(links.submit));
      if (back) back.addEventListener('click', () => navigate(links.back));
    };

    if (iframeRef.current) iframeRef.current.addEventListener('load', handleIframeLoad);

    return () => {
      if (iframeRef.current) iframeRef.current.removeEventListener('load', handleIframeLoad);
    };
  }, []);

  return (
    <iframe
      ref={iframeRef}
      title="e-insert-management-edit"
      src={path}
      className="z-[100] relative"
      width="100%"
      height="700px"
    />
  );
}

export default EInsertManagementEdit;
